import React from 'react';
import './CaseStudy.css';

const study = {
  id: 1,
  brandName: 'Rameti Jewels',
  badge: 'Verified Success Story',
  impact: 'Rameti Jewels now showcases products effortlessly with premium model imagery, boosting their e-commerce experience and conversions.',
  description: 'Rameti Jewels partnered with Glammify to enhance their jewellery showcasing using AI.',
  challenges: [
    'High cost of model photoshoots',
    'Time-consuming content creation',
    'Difficulty maintaining consistent visuals',
  ],
  benefits: [
    'Reduced costs & faster turnaround',
    'Consistent brand visuals',
    'Scalable content creation',
    'Improved online engagement',
  ],
  solution: 'In association with Glammify, they created AI-generated model images without traditional shoots. The visuals are Shopify-compatible with API integration for easy scalability.',
};

const CaseStudy = ({ id }) => {
  return (
    <section className="cs-section" id={id}>
      <div className="container-fluid">

        {/* Section Heading */}
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-10">
            <h2 className="cs-section-heading">
              <span className="cs-heading-black">Real Results from</span>{' '}
              <span className="cs-heading-purple">Real Jewellers</span>
            </h2>
          </div>
        </div>

        {/* Main Card */}
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-10">
            <div className="cs-card">
              <div className="row g-0 align-items-center">

                {/* Left: Case Study Image */}
                <div className="col-md-5 col-lg-5">
                  <div className="cs-image-wrap text-center">
                    <img
                      src="/assets/img/website/case-study-image.svg"
                      alt="Case Study"
                      className="img-fluid cs-main-image"
                    />
                  </div>
                </div>

                {/* Right: Content */}
                <div className="col-md-7 col-lg-7">
                  <div className="cs-content">
                    {/* Badge */}
                    <div className="cs-badge">
                      <img src="/assets/img/website/verified.svg" alt="Verified" className="cs-verified-icon" />
                      {study.badge}
                    </div>

                    {/* Impact Box */}
                    <div className="cs-impact-box">
                      <div className="cs-impact-title">Impact</div>
                      <p className="cs-impact-text">{study.impact}</p>
                    </div>

                    {/* Brand heading & description */}
                    <h3 className="cs-brand-name">{study.brandName}</h3>
                    <p className="cs-brand-desc">{study.description}</p>

                    {/* Two-column list */}
                    <div className="row cs-lists-row">
                      <div className="col-12 col-md-6 mb-3 mb-md-0">
                        <div className="cs-list-heading">
                          <span className="cs-list-icon">
                            <img src="/assets/img/website/challenges.svg" alt="Challenges" className="cs-list-icon-img" />
                          </span>
                          Challenges
                        </div>
                        <ul className="cs-list">
                          {study.challenges.map((item, i) => (
                            <li key={i}><span className="cs-bullet cs-bullet-purple"></span>{item}</li>
                          ))}
                        </ul>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="cs-list-heading">
                          <span className="cs-list-icon">
                            <img src="/assets/img/website/key-benefits.svg" alt="Benefits" className="cs-list-icon-img" />
                          </span>
                          Key Benefits
                        </div>
                        <ul className="cs-list">
                          {study.benefits.map((item, i) => (
                            <li key={i}><span className="cs-bullet cs-bullet-orange"></span>{item}</li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* Solution */}
                    <div className="cs-solution">
                      <span className="cs-solution-label">Solution</span>
                      <p className="cs-solution-text">{study.solution}</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default CaseStudy;
